module.exports = __webpack_public_path__ + "static/media/forsoka.18957f1c.mp3";